import { TbCheck } from 'react-icons/tb'
import { Text } from 'ui-kit/typography'
import { getIntegrationUrl } from 'routes/Integrations/helpers'
import { collectionOperations } from 'routes/Integrations/helpers/collectionOperations'
import { INTEGRATION_QUERIES } from 'routes/constants'
import NavLink from 'ui-kit/actions/link/NavLink'
import clsx from 'clsx'
import common from 'routes/Integrations/Integration/Integration.module.scss'
import classes from './DataCollections.module.scss'

export function IntegrationDataCollectionsCard({
  collection,
  udmsData,
  integrationLink,
}) {
  const { name, key, events, customFieldsSchema } = collection

  const eventsData = events && Object.keys(events)

  const operationsToShow = collectionOperations.filter((o) =>
    o.check(collection),
  )

  const showDataContent =
    operationsToShow.length > 0 ||
    eventsData ||
    udmsData.length > 0 ||
    customFieldsSchema

  return (
    <li className={common.integrationItem}>
      <NavLink
        className={common.integrationLink}
        href={getIntegrationUrl(
          integrationLink,
          INTEGRATION_QUERIES.DATA_COLLECTIONS,
          key,
        )}
      >
        {name}
      </NavLink>

      {showDataContent && (
        <div className={classes.content}>
          <div className={classes.tags}>
            {operationsToShow.length > 0 && (
              <div className={classes.wrapper}>
                <Text className={classes.caption}>Operations:</Text>
                {operationsToShow.map(({ key }) => (
                  <Text as={'span'} key={key} className={classes.tag}>
                    {key}
                  </Text>
                ))}
              </div>
            )}
            {eventsData && (
              <div className={classes.wrapper}>
                <Text className={classes.caption}>Events:</Text>
                {eventsData.map((event: string, idx: number) => (
                  <Text as={'span'} key={idx} className={classes.tag}>
                    {event}
                  </Text>
                ))}
              </div>
            )}
            {udmsData.length > 0 && (
              <div className={classes.wrapper}>
                <Text className={classes.caption}>Universal models:</Text>
                {udmsData.map((udm: string, idx: number) => (
                  <Text as={'span'} key={idx} className={classes.tag}>
                    {udm}
                  </Text>
                ))}
              </div>
            )}
          </div>

          {customFieldsSchema && (
            <div className={clsx(classes.wrapper, classes.wrapper__support)}>
              <div className={classes.round}>
                <TbCheck />
              </div>
              <Text as={'span'} className={classes.support}>
                supports custom fields
              </Text>
            </div>
          )}
        </div>
      )}
    </li>
  )
}
